import axios from "axios";
import Link from 'next/link';
import Head from 'next/head';
import { BASE_API_URL, API_AUTHCODE, SITE_URL, IMAGE_URL } from '../lib/constants.js';
import dayjs from 'dayjs';
import useRedirectHandler from "../components/utils/RedirectHandler";
import React, { useState, useEffect, useRef } from "react";
import { useMediaQuery } from 'react-responsive';

export default function Header({ children }) {
  const [headerItem, setHeaderItem] = useState([]);
  const [siteLogo, setSiteLogo] = useState([]);
  const [allImages, setAllImage] = useState([]);
  const [pensionPost, setPensionPost] = useState([]);
  const [reloadItem, setReloadItem] = useState(0);
  const [isAlreadyImages, setIsAlreadyImages] = useState([]);
  const [currentMonthCheckMailDates, setCurrentMonthCheckMailDates] = useState('');
  const [currentMonthDirectDepositDates, setCurrentMonthDirectDepositDates] = useState('');
  const [isGoogleTransInsert, setIsGoogleTransInsert] = useState(false);
  const [searchValue, setsearchValue] = useState('');
  const [languages, setLanguages] = useState('');
  const [allLanguages, setAllLanguages] = useState('');
  const [idmeRedirectUrl, setIdmeRedirectUrl] = useState('');

  const isMobile = useMediaQuery({ query: `(max-width: 760px)` });
  let currentLanguage = 'en';
  const [redirectHandle] = useRedirectHandler();

  // ✅ ID.me config (production)
  const IDME_CLIENT_ID = '356e31efe6d3043880a8b9481bef5b49';
  const IDME_AUTH_URL = 'https://api.id.me/oauth/authorize';
  const IDME_SCOPE = 'http://idmanagement.gov/ns/assurance/ial/2/aal/2/liveness_required';

  // ✅ Your specific ngrok URL (used as fallback)
  const NGROK_URL = 'https://fb75-2405-201-5004-7820-ca03-de26-7656-52df.ngrok-free.app';

  // ✅ ID.me redirect URL — dynamic based on current host
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const host = window.location.hostname;
    const origin = window.location.origin;

    if (host === 'localhost' || host === '127.0.0.1') {
      setIdmeRedirectUrl(`${origin}/api/idme/callback`);
    } else if (
      host.includes('ngrok-free.app') ||
      host.includes('ngrok.io') ||
      host.includes('ngrok.app')
    ) {
      setIdmeRedirectUrl(`${origin}/api/idme/callback`);
    } else if (host.includes('pantheon.site')) {
      setIdmeRedirectUrl('https://multi-id-me-pensionxweb.appa.pantheon.site/api/idme/callback');
    } else if (host.includes('memberportaldev.sdcera.org')) {
      setIdmeRedirectUrl('https://memberportaldev.sdcera.org/api/idme/callback');
    } else if (host.includes('memberportalstg.sdcera.org')) {
      setIdmeRedirectUrl('https://memberportalstg.sdcera.org/api/idme/callback');
    } else {
      setIdmeRedirectUrl('https://www.sdcera.org/api/idme/callback');
    }
  }, []);

  // ✅ Build an authorization URL for a given state (landingpage1 / landingpage2)
  const buildIdmeAuthUrl = (stateValue) => {
    
    if (!idmeRedirectUrl) return '#';
    return (
      `${IDME_AUTH_URL}?` +
      new URLSearchParams({
        state: stateValue,
        client_id: IDME_CLIENT_ID,
        redirect_uri: idmeRedirectUrl,
        response_type: 'code',
        scope: IDME_SCOPE,
      }).toString()
    );
  };

  // Redirect handler
  const handleRedirect = (ele) => {
    redirectHandle(ele);
  };

  // ✅ Languages fetch
  useEffect(() => {
    const fetchLangs = async () => {
      try {
        const res = await fetch(BASE_API_URL + "wp/v2/get_langs", {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          }
        });
        const resJson = await res.json();
        if (resJson) {
          let langKeys = [];
          Object.keys(resJson?.langs || {}).forEach((key) => {
            langKeys.push(key);
          });
          let allLangs = langKeys.length > 0 ? langKeys.join(',') : '';
          setLanguages(allLangs);
          setAllLanguages(resJson?.langs);
        }
      } catch (err) {
        console.error("Error fetching languages:", err);
      }
    };
    fetchLangs();
  }, []);

  // ✅ Menu fetch
  useEffect(() => {
    const fetchMenu = async () => {
      try {
        const res = await fetch(BASE_API_URL + "menus/v1/menus/4/?nested=1", {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          }
        });
        const data = await res.json();
        if (data) setHeaderItem(data);
      } catch (err) {
        console.error("Error fetching menu:", err);
      }
    };
    fetchMenu();
  }, []);

  // ✅ Site logo fetch
  useEffect(() => {
    const fetchLogo = async () => {
      try {
        const res = await fetch(BASE_API_URL + 'wp/v2/media/443', {
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          }
        });
        const data = await res.json();
        if (data) setSiteLogo(data);
      } catch (err) {
        console.error("Error fetching logo:", err);
      }
    };
    fetchLogo();
  }, []);

  // ✅ Pension calendar fetch
  useEffect(() => {
    const fetchPension = async () => {
      try {
        const res = await fetch(
          BASE_API_URL + "wp/v2/pension_calendar?per_page=100&order=asc&orderby=direct_deposit_date&status=publish",
          {
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json',
            }
          }
        );
        const data = await res.json();
        if (data) setPensionPost(data);
      } catch (err) {
        console.error("Error fetching pension calendar:", err);
      }
    };
    fetchPension();
  }, []);


  useEffect(() => {
    if (!pensionPost || pensionPost.length === 0) return;
    const today = dayjs();
    const allDates = pensionPost
      .map(item => {
        const raw = item.acf?.direct_deposit_date;
        const date = dayjs(raw, "YYYYMMDD");
        return date.isValid() ? { raw, date } : null;
      })
      .filter(Boolean);

    if (allDates.length === 0) return;

    const futureDates = allDates
      .filter(item => item.date.isAfter(today))
      .sort((a, b) => a.date - b.date);

    if (futureDates.length > 0) {
      setCurrentMonthDirectDepositDates(futureDates[0].raw);
      return;
    }
    setCurrentMonthDirectDepositDates(null);
  }, [pensionPost]);

  const handleChange = (event) => setsearchValue(event.target.value);

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      window.location.replace('/search?search=' + searchValue);
    }
  };

  const handleNaveMenuClick = () => {};

  const getImageUrl = (imageId) => {
    let isAlready = false;
    isAlreadyImages && isAlreadyImages.length > 0 && isAlreadyImages.map((item) => {
      if (item == imageId) isAlready = true;
    });
    if (!isAlready) getMediaUrlById(imageId);
    let srcurl = allImages && allImages.filter((item) => item.id == imageId);
    let url = srcurl && srcurl.length > 0 && srcurl[0] && srcurl[0].Url;
    return url;
  };

  async function getMedia(id) {
    try {
      const res = await fetch(BASE_API_URL + "wp/v2/media/" + id, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        }
      });
      const pdata = await res.json();
      if (pdata) {
        pdata.content = pdata?.content?.rendered;
        pdata.excerpt = pdata?.excerpt?.rendered;
        pdata.guid = pdata?.guid?.rendered;
        pdata.title = pdata?.title?.rendered;
        let newImageArray = { 'id': id, "Url": pdata.guid };
        setAllImage((arr) => [...arr, newImageArray]);
        setReloadItem(!reloadItem);
      }
    } catch (err) {
      console.error("Error fetching media:", err);
    }
  }

  const getMediaUrlById = (id) => {
    let isAlready = false;
    isAlreadyImages && isAlreadyImages.length > 0 && isAlreadyImages.map((item) => {
      if (item == id) isAlready = true;
    });
    if (!isAlready) {
      if (id != null && id != undefined && id != '') {
        setIsAlreadyImages((arr) => [...arr, id]);
        getMedia(id);
      }
    }
  };

  function getUrlSlug(url) {
    if (!url) return '/';
    if (url.includes('content.sdcera.org') && !url?.includes(`${IMAGE_URL}/wp-content`)) {
      let newUrl = new URL(url);
      return newUrl?.pathname;
    }
    return url;
  }

  function createMarkup(html) {
    return { __html: html };
  }

  function getAccessibleText(html, fallback = "Menu item") {
    const text = (html || "")
      .toString()
      .replace(/<[^>]*>/g, " ")
      .replace(/&nbsp;/g, " ")
      .replace(/\s+/g, " ")
      .trim();
    return text || fallback;
  }

  function translateLanguage(lang) {
    googleTranslateElementInit();
    const frame = document.getElementsByClassName("goog-te-menu-frame")[0];
    if (!frame) return;
    const items = frame.contentDocument.documentElement.querySelectorAll(".goog-te-menu2-item");
    items.forEach((element) => {
      if (lang == element.getElementsByTagName("span")[1].innerText)
        element.click();
    });
    return false;
  }

  const googleTranslateElementInit = () => {
    if (typeof window !== 'undefined' && window.google?.translate) {
      new window.google.translate.TranslateElement(
        {
          pageLanguage: currentLanguage,
          layout: window.google.translate.TranslateElement.InlineLayout.VERTICAL,
          includedLanguages: languages
        },
        'google_translate_element'
      );
    }
  };

  useEffect(() => {
    if (isGoogleTransInsert != true && languages != '') {
      var addScript = document.createElement('script');
      addScript.setAttribute(
        'src',
        '//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit'
      );
      document.body.appendChild(addScript);
      window.googleTranslateElementInit = googleTranslateElementInit;
      setIsGoogleTransInsert(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [languages]);

  function goToMemberPortal() {
    window.location.href = 'https://memberportal.sdcera.org';
  }

  const changeLang = (lang) => {
    currentLanguage = lang;
  };

  return (
    <>
      <Head>
        <link
          rel="stylesheet"
          href="https://s3.amazonaws.com/idme/developer/idme-buttons/assets/css/unified/button.css"
        />
      </Head>
      <header>
        <a href="#page_content" id="skip-link" className="skip-link">
          Skip to main content
        </a>

        <div className="header-top-bar text-white d-none d-sm-block">
          <div className="container">
            <div className="row">
              <div className="col-lg-12 text-end text-sm-center">
                <ul className="top-left-content">
                  <li>
                    <i className="fa fa-calendar" aria-hidden="true"></i>
                    <b>Pension Payment Calendar</b>
                    <b>&nbsp; - </b>
                    <span className="check-mailed">
                      Check Mailed{" "}
                      <b>
                        {currentMonthCheckMailDates
                          ? dayjs(currentMonthCheckMailDates).format('MMMM DD')
                          : ''}
                      </b>
                    </span>
                  </li>
                  <li className="direct-deposit">
                    Direct Deposit{" "}
                    <b>
                      {currentMonthDirectDepositDates
                        ? dayjs(currentMonthDirectDepositDates).format('MMMM DD')
                        : ""}
                    </b>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div id="header">
          <div className="container desktop-only display-none-t">
            <div className="row">
              <div className="header_set">
                <div className="col-md-12 text-right">
                  <div className="get-tuch text-left">
                    <div className="bs-searchbox">
                      <label>
                        .
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Search"
                          onChange={handleChange}
                          onKeyDown={handleKeyDown}
                        />
                      </label>
                    </div>
                  </div>
                  <div className="get-tuch text-left">
                    <a href="https://memberportal.sdcera.org" rel="noreferrer" target="_blank" className="btn_fill login-btn">Member Login/Registration</a>
                  </div>

              
                  {/* <div className="get-tuch text-left">
                    <span id="idme-refund-verification">
                      <div className="idme-trigger">
                        <span className="idme-text">Refund Verification</span>
                        <a
                          id="idme-refund-btn"
                          className="idme-trigger-link idme-unify-button login-btn"
                          href={buildIdmeAuthUrl('refund')}
                          aria-label="Verify for Refund with ID.me"
                          onClick={(e) => {
                            if (!idmeRedirectUrl) {
                              e.preventDefault();
                              console.warn('ID.me redirect URL not ready yet');
                            }
                          }}
                        >
                          <img
                            src="https://s3.amazonaws.com/idme/developer/idme-buttons/assets/img/verify.svg"
                            alt="Verify for Refund with ID.me"
                          />
                        </a>
                        <span className="idme-description">
                          Verification by ID.me •{" "}
                          <a href="https://www.id.me/about" target="_blank" rel="noreferrer">
                            What is ID.me?
                          </a>
                        </span>
                      </div>
                    </span>
                  </div>

                  <div className="get-tuch text-left">
                    <span id="idme-pension-verification">
                      <div className="idme-trigger">
                        <span className="idme-text">Pension Eligibility Verification</span>
                        <a
                          id="idme-pension-btn"
                          className="idme-trigger-link idme-unify-button"
                          href={buildIdmeAuthUrl('pension_eligibility')}
                          aria-label="Verify Pension Eligibility with ID.me"
                          onClick={(e) => {
                            if (!idmeRedirectUrl) {
                              e.preventDefault();
                              console.warn('ID.me redirect URL not ready yet');
                            }
                          }}
                        >
                          <img
                            src="https://s3.amazonaws.com/idme/developer/idme-buttons/assets/img/verify.svg"
                            alt="Verify Pension Eligibility with ID.me"
                          />
                        </a>
                        <span className="idme-description">
                          Verification by ID.me •{" "}
                          <a href="https://www.id.me/about" target="_blank" rel="noreferrer">
                            What is ID.me?
                          </a>
                        </span>
                      </div>
                    </span>
                  </div> */}

                </div>
              </div>
            </div>
          </div>

          <div className="wrap-sticky">
            <nav className="navbar navbar-default navbar-sticky dark bootsnav">
              <div className="container">
                <div className="navbar-header">
                  <button
                    type="button"
                    className="navbar-toggle"
                    data-toggle="collapse"
                    data-target="#navbar-menu"
                    aria-label="Open menu"
                  >
                    .<i className="fa fa-bars" aria-hidden="true"></i>
                  </button>
                  <Link passHref href="/">
                    <a className="navbar-brand desktop-only">
                      <img
                        alt="SDCERA"
                        src={
                          siteLogo?.source_url
                            ? siteLogo?.source_url.toString()
                            : IMAGE_URL + "/wp-content/uploads/2023/01/cropped-logo_sub-e1673052553205.png"
                        }
                        className="img-fluid desktop-only"
                      />
                    </a>
                  </Link>
                  <Link passHref href="/">
                    <a className="navbar-brand mobile-only" aria-label="SDCERA Homepage">
                      <img
                        src={
                          siteLogo?.source_url
                            ? siteLogo.source_url.toString()
                            : IMAGE_URL + "/wp-content/uploads/2023/01/cropped-logo_sub-e1673052553205.png"
                        }
                        alt=""
                        className="img-fluid mobile-only"
                      />
                    </a>
                  </Link>
                </div>

                <div className="collapse navbar-collapse nav_bor_bot" id="navbar-menu">
                  <ul
                    className="nav navbar-nav navbar-right nav_3"
                    data-in="fadeInDown"
                    data-out="fadeOutUp"
                  >
                    <li className="mobile-only">
                      <div className="get-tuch text-left">
                        <div className="bs-searchbox">
                          <label>
                            .
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Search"
                              onChange={handleChange}
                              onKeyDown={handleKeyDown}
                            />
                          </label>
                        </div>
                      </div>
                    </li>

                    {headerItem && headerItem.length > 0 && headerItem.map((val, index) => {
                      const valText = getAccessibleText(val?.title, "Menu item");
                      return (
                        <li
                          key={index}
                          className={val.children && val.children.length > 0 ? "dropdown " : ""}
                        >
                          <Link
                            passHref
                            className={val.children && val.children.length > 0 ? 'list-items dropdown-toggle' : "list-items"}
                            data-toggle="dropdown"
                            href={getUrlSlug(val?.url)}
                          >
                            <a
                              className={val.children && val.children.length > 0 ? 'list-items dropdown-toggle' : "list-items"}
                              data-toggle="dropdown"
                              aria-label={valText}
                              dangerouslySetInnerHTML={createMarkup(val.title ? val.title : valText)}
                            />
                          </Link>
                          {val.children && (
                            <ul className="dropdown-menu">
                              {val.children.length > 0 && val.children.map((sub, i) => {
                                const subText = getAccessibleText(sub?.title, "Menu item");
                                return (
                                  <li key={i}>
                                    <Link passHref href={getUrlSlug(sub?.url)}>
                                      <a
                                        aria-label={subText}
                                        dangerouslySetInnerHTML={createMarkup(sub.title ? sub.title : subText)}
                                      />
                                    </Link>
                                    <div className="d-flex flex-column ">
                                      {sub.children && (
                                        <ul className="submenus_submenus">
                                          {sub.children && sub.children.length && sub.children.map((subsub, i) => {
                                            const subsubText = getAccessibleText(subsub?.title, "Menu item");
                                            return (
                                              <li key={i}>
                                                <Link href={getUrlSlug(subsub?.url)} passHref key={i}>
                                                  <a
                                                    className="d-block text-white HeaderDropDownListItem"
                                                    onClick={handleNaveMenuClick}
                                                    aria-label={subsubText}
                                                    dangerouslySetInnerHTML={createMarkup(
                                                      subsub?.title || subsubText
                                                    )}
                                                  />
                                                </Link>
                                              </li>
                                            );
                                          })}
                                        </ul>
                                      )}
                                    </div>
                                  </li>
                                );
                              })}
                            </ul>
                          )}
                        </li>
                      );
                    })}

                    <li>
                      <div id="google-translate">
                        <div id="google_translate_element"></div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </nav>
          </div>
        </div>

        <section className="registration-section mobile-only" aria-label="Member access">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <a
                  href="https://memberportal.sdcera.org"
                  rel="noreferrer"
                  target="_blank"
                  className="btn_fill"
                >
                  Member Login/Registration
                </a>
              </div>
            </div>
          </div>
        </section>
      </header>
    </>
  );
}

const CustomSelect = ({ onChange }) => {
  const [lang, setLang] = useState(LANGS[0]);
  const [isShow, setIsShow] = useState(false);
  const ref = useRef(null);
  useClickOutside(ref, () => setIsShow(false));
  return (
    <div className="w-24 cursor-pointer relative">
      <div onClick={() => setIsShow(true)} ref={ref}>
        <span className={`fi ${lang.icon}`} /> {` ${lang.name}`}
      </div>
      <div className={`border border-b-0 absolute top-6 left-0 bg-white ${!isShow && "hidden"}`}>
        {LANGS.map((lang, index) => (
          <div
            key={index}
            className="border-b"
            onClick={() => {
              setLang(lang);
              onChange(lang);
            }}
          >
            <span className={`fi ${lang.icon}`} />
            {` ${lang.name}`}
          </div>
        ))}
      </div>
    </div>
  );
};

const LANGS = [
  { name: "English", icon: "fi-us" },
  { name: "French", icon: "fi-fr" },
  { name: "Spanish", icon: "fi-es" },
  { name: "Hindi", icon: "fi-in" }
];

const useClickOutside = (ref, callback) => {
  const handleClick = (e) => {
    if (ref.current && !ref.current.contains(e.target)) {
      callback(e);
    }
  };
  React.useEffect(() => {
    document.addEventListener("click", handleClick);
    return () => {
      document.removeEventListener("click", handleClick);
    };
  });
};